;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.scrollToGallery = (function () {
    const initialize = function () {
      $('.js-inspirationScrollTo').click(function () {
        $('html,body').animate({
          scrollTop: $('#inspirationGalleryDiv').offset().top - 40
        }, 'slow')
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.scrollToGallery.initialize()
  })
}(jQuery, window))
